export default __webpack_public_path__ + "static/media/chooseMaltoKuk.eb9b48e9.png";